(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxContentWidgetViewDialogPage', {
		bindings: { parameters: '=?' },
		controller: MxContentWidgetViewDialogPageCtrl,
		controllerAs: 'vm',
		template: '<div class="flex layout-column" mx-transclude></div>',
		transclude: true,
	});

	MxContentWidgetViewDialogPageCtrl.$inject = [];

	function MxContentWidgetViewDialogPageCtrl() {
		var vm = this;

		vm.$onInit = function () {
			vm.dataModel = vm.parameters;
		};

		return vm;
	}
})();
